import { Info as InfoIcon, InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import type { MouseEvent } from 'react';

import VNFieldHelpHoverTip from './VNFieldHelpHoverTip';

type Props = {
  active: boolean;
  helperTooltip?: string;
  onClick?: () => void;
  ariaLabel?: string;
};

const VNFieldHelpIconButton = ({ active, helperTooltip, onClick, ariaLabel }: Props) => {
  const handleClick = onClick
    ? (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick();
      }
    : undefined;

  const button = (
    <IconButton
      size="small"
      onClick={handleClick}
      className={['vn-field-help__btn', 'vn-field-help__btn--info', active ? 'vn-field-help__btn--active' : '']
        .filter(Boolean)
        .join(' ')}
      aria-label={ariaLabel ?? (active ? 'Hide help text' : 'Show help text')}
    >
      <InfoOutlinedIcon fontSize="small" className="vn-field-help__btn-icon vn-field-help__btn-icon--default" />
      <InfoIcon fontSize="small" className="vn-field-help__btn-icon vn-field-help__btn-icon--highlighted" />
    </IconButton>
  );

  return (
    <VNFieldHelpHoverTip title={helperTooltip}>
      <span className="vn-field-help__btn-wrap">{button}</span>
    </VNFieldHelpHoverTip>
  );
};

export default VNFieldHelpIconButton;
